/* eslint-disable react/no-danger */
import each from 'lodash/each';
import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import styles from './index.scss';

export default class HTMLFragment extends Component {
  uniqueId = uniqueId('HTMLFragment_');
  static propTypes = {
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
  };
  componentDidMount() {
    try {
      const parentNode = document && document.getElementById(this.uniqueId);
      each(
        // find any empty elements inside the container
        parentNode.querySelectorAll(':empty'),
        // get rid of them!
        childNode => parentNode.removeChild(childNode),
      );
    } catch (e) {
      // error trap
    }
  }
  render() {
    const { children, className, ...props } = this.props;
    return (
      <div
        {...props}
        id={this.uniqueId}
        className={[styles.container, className].join(' ')}
        dangerouslySetInnerHTML={{
          __html: children,
        }}
      />
    );
  }
}
